import React from 'react';
import { useHistory } from 'react-router-dom';
import Handler from '../../Handler';
import { RadioBox, FileUploader, TextInput } from '../../components';
import _ from 'lodash';

export const SelectEvidence = (props) => {
  const history = useHistory();
  const { value, onChange, meta } = props;
  console.log('SelectEvidence meta', meta);
  const onCahngeItem = (new_item, index) => {
    let new_evidence = _.clone(value);
    new_evidence[index] = new_item;
    onChange(new_evidence, 'evidence');
  };

  const renderHeader = (item, index) => {
    return (
      <header>
        <span>{meta.label[index].title}</span>
        {meta.label[index].isForce ? <span>*</span> : null}
      </header>
    );
  };
  const renderRadioBox = (item, index) => {
    let target_meta = meta.label[index];
    // console.log('target_meta', target_meta);

    if (target_meta.isForce) {
      return null;
    }
    return (
      <div className='radio__box'>
        <RadioBox
          value={item.type}
          onChange={(value, key) => {
            // console.log('value', value);
            // console.log('key', key);
            let new_item = _.clone(item);
            new_item.type = value;
            new_item.data = '';
            onCahngeItem(new_item, index);
          }}
          meta={{
            key: 'radio',
            menus: [
              {
                text: '제출함',
                value: 'File',
              },
              {
                text: '제출안함',
                value: 'Reason',
              },
            ],
            disabled: meta.disabled,
            readOnly: meta.readOnly,
          }}
        ></RadioBox>
      </div>
    );
  };

  const renderFileBox = (item, index) => {
    let target_meta = meta.label[index];
    // console.log('target_meta', target_meta);

    if (item.type === 'File') {
      return (
        <div className='file__box'>
          <FileUploader
            value={item.data}
            onChange={(value, key) => {
              console.log('value', value);
              console.log('key', key);
              let new_item = _.clone(item);
              new_item.data = value;
              onCahngeItem(new_item, index);
            }}
            meta={{
              type: 'file',
              key: 'evidence-item-' + index,
              path: 'dummy',
              required: false,
              disabled: meta.disabled,
              readOnly: meta.readOnly,
            }}
          ></FileUploader>
        </div>
      );
    }
  };

  const renderTextInputBox = (item, index) => {
    if (item.type === 'Reason') {
      return (
        <div className='text-input__box'>
          <TextInput
            value={item.data}
            onChange={(value, key) => {
              console.log('value', value);
              console.log('key', key);
              let new_item = _.clone(item);
              new_item.data = value;
              onCahngeItem(new_item, index);
            }}
            meta={{
              key: 'text',
              required: false,
              disabled: meta.disabled,
              readOnly: meta.readOnly,
            }}
          ></TextInput>
        </div>
      );
    }
  };

  if (meta && meta.label && meta.label.length === 0) {
    return null;
  }
  if (value && value.length === 0) {
    return null;
  }
  return (
    <article
      className={Handler.BuildArticleClassname('form-select-evidence', meta)}
      style={meta && meta.style ? { ...meta.style } : {}}
    >
      {value &&
        value.length > 0 &&
        value.map((item, index) => {
          return (
            <div className='evidence-item'>
              {renderHeader(item, index)}
              {renderRadioBox(item, index)}
              {renderFileBox(item, index)}
              {renderTextInputBox(item, index)}
            </div>
          );
        })}
    </article>
  );
};
